<template>
    <main class="page-main" v-if="loading === false">
        <page-menu :menu="menu"></page-menu>

        <home-movies v-if="items.movies" :meta="menu[0]"
                     :items="items.movies"
                     :slides="slides"
                     :bgimg="bgImages.movies"></home-movies>

        <home-tv v-if="items.tv" :meta="menu[1]" :items="items.tv"
                 :bgimg="bgImages.tv"></home-tv>

        <home-kids v-if="items.kids" :meta="menu[2]" :items="items.kids" :bgimg="bgImages.kids"></home-kids>

        <home-music v-if="items.music" :meta="menu[3]" :items="items.music" :bgimg="bgImages.music"></home-music>

        <home-games v-if="items.games" :meta="menu[4]" :items="items.games" :bgimg="bgImages.games" ></home-games>
    </main>
</template>

<script>
    // @ is an alias to /src

    import PageMenu from "../components/PageMenu";
    import HomeMovies from "../components/HomeMovies";
    import {hideCaptions} from '../outer-js'
    import HomeKids from "../components/HomeKids";
    import HomeTv from "../components/HomeTv";
    import HomeMusic from "../components/HomeMusic";
    import HomeGames from "../components/HomeGames";
    import {mapGetters} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: 'home',
        components: {
            HomeGames,
            HomeMusic,
            HomeTv,
            HomeKids,
            HomeMovies,
            PageMenu
        },
        data() {
            return {
                items: false,
                slides: false,
                mainLoading: true
            }
        },
        computed: {
            ...mapGetters({
                menu: 'getMenu',
                loading: 'getLoading',
                lang: 'getLang',
                preview: 'getPreview',
            })
        },
        created() {
            if(this.$route.query.set) {
                this.setPreview(this.$route.query.set);
            }
            this.getMainPageData();
        },
        mounted() {
            $(window).scroll(function () {
                hideCaptions();
            });
        },
        methods: {
            ...mapActions({
                setPreview : 'setPreviewAsync',
            }),
            getMainPageData() {
                this.mainLoading = true;
                this.axios.get(this.lang + '/main_page'+ (this.preview ? ('?set=' + this.preview) : ''))
                    .then(response => {
                        this.slides = response.data.data.slides;
                        this.items = response.data.data.items;
                        this.bgImages = response.data.data.bgImages;
                        this.mainLoading = false;
                    })
                    .catch(error =>{
                        console.log(error, error.response);
                        this.mainLoading = true;
                    });
            },
        },
    }
</script>
